module.exports = __webpack_public_path__ + "static/img/new-garbanner.26e2672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/new-garbanner.png
// module id = 4pe+
// module chunks = 44